import React, { useState, useEffect } from "react";
import { Globe, ArrowRight } from "lucide-react";

const NewsSection = () => {
  const news = [
    {
      title: "Kuba Meridian Group Launches with Vision for African Excellence",
      date: "September 2024",
      excerpt:
        "Our holding company begins its journey to transform industries across Africa through strategic partnerships and innovative solutions that honor tradition while embracing global standards.",
      category: "Company News",
      color: "from-blue-500 to-blue-600",
    },
    {
      title: "Malikia Consulting Engineers Joins the Group",
      date: "August 2024",
      excerpt:
        "We welcome our first subsidiary, bringing world-class engineering expertise and African innovation to our growing portfolio of excellence-driven companies.",
      category: "Expansion",
      color: "from-emerald-500 to-emerald-600",
    },
    {
      title: "Building Bridges: Infrastructure for African Growth",
      date: "July 2024",
      excerpt:
        "Exploring the critical role of sustainable infrastructure development in driving economic growth and social progress across the African continent and beyond.",
      category: "Insights",
      color: "from-yellow-500 to-yellow-600",
    },
  ];

  return (
    <section
      id="news"
      className="py-24 bg-gradient-to-br from-blue-50/30 via-emerald-50/20 to-slate-50 relative overflow-hidden"
    >
      {/* Background elements */}
      <div className="absolute top-20 left-20 w-64 h-64 bg-gradient-to-br from-blue-400/10 to-emerald-400/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-20 w-48 h-48 bg-gradient-to-br from-yellow-400/10 to-blue-400/10 rounded-full blur-2xl"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-block p-3 bg-gradient-to-r from-blue-500/10 to-emerald-500/10 rounded-full mb-6 border border-blue-200">
            <Globe className="w-8 h-8 text-blue-600" />
          </div>
          <h2 className="text-5xl md:text-7xl font-black text-slate-900 mb-8">
            Latest{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 via-emerald-600 to-yellow-500">
              News & Insights
            </span>
          </h2>
          <div className="w-32 h-1.5 bg-gradient-to-r from-blue-500 via-emerald-500 to-yellow-500 mx-auto mb-10 rounded-full"></div>
          <p className="text-2xl text-slate-600 max-w-4xl mx-auto font-light">
            Stay updated with our latest milestones, achievements, and industry
            insights as we build the future of African enterprise.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-10">
          {news.map((article, index) => (
            <article
              key={index}
              className="group bg-white/80 backdrop-blur-sm rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 border border-white/50 overflow-hidden"
            >
              <div className="p-8">
                <div className="flex items-center justify-between mb-6">
                  <span
                    className={`bg-gradient-to-r ${article.color} text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg`}
                  >
                    {article.category}
                  </span>
                  <span className="text-slate-500 text-sm font-medium bg-slate-100 px-3 py-1 rounded-full">
                    {article.date}
                  </span>
                </div>

                <h3 className="text-2xl font-bold text-slate-900 mb-6 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-blue-600 group-hover:via-emerald-600 group-hover:to-yellow-500 transition-all duration-300 leading-tight">
                  {article.title}
                </h3>

                <p className="text-slate-600 mb-8 leading-relaxed text-lg">
                  {article.excerpt}
                </p>

                <button className="group w-full bg-gradient-to-r from-slate-900 to-blue-900 hover:from-emerald-600 hover:to-blue-600 text-white py-4 rounded-xl font-bold flex items-center justify-center space-x-2 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105">
                  <span>Read Full Article</span>
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
            </article>
          ))}
        </div>

        {/* Call to action */}
        <div className="text-center mt-16">
          <button className="bg-gradient-to-r from-emerald-500 via-blue-500 to-yellow-500 hover:from-yellow-500 hover:via-emerald-500 hover:to-blue-500 text-white px-12 py-5 rounded-full font-bold text-lg transition-all duration-300 shadow-2xl hover:shadow-emerald-500/25 transform hover:scale-105">
            View All News & Insights
          </button>
        </div>
      </div>
    </section>
  );
};
export default NewsSection;
